 <app-mrp-scrolltop></app-mrp-scrolltop>

<section id="main" class="wrapper">
    <div class="inner">
        <div class="content">            
            <div class="row">
                <div class="col-12-medium">   

                    <mat-tab-group
                        [selectedIndex]="selectedTabIndex"
                        (selectedIndexChange)="onTabChange($event)"
                        animationDuration="500ms"   >
                        
                        <mat-tab label="Video">                            
                            <ng-template matTabContent>
                                <div class="tab-content-wrapper">
                                
                                    <app-video></app-video>                                    
                               
                                </div>
                            </ng-template>
                        </mat-tab>

                        <mat-tab label="Audio">                            
                            <ng-template matTabContent>
                                <div class="tab-content-wrapper">

                                    <app-audio-library></app-audio-library>                                
                              
                                </div>
                            </ng-template>
                        </mat-tab>
                    </mat-tab-group>
                   
                </div>              
            </div>
           
        </div>
           
    </div>
</section>





















 
